import { render, staticRenderFns } from "./AdminPanelDashboardDialogFile.vue?vue&type=template&id=209ee2b4"
import script from "./AdminPanelDashboardDialogFile.vue?vue&type=script&lang=js"
export * from "./AdminPanelDashboardDialogFile.vue?vue&type=script&lang=js"
import style0 from "./AdminPanelDashboardDialogFile.vue?vue&type=style&index=0&id=209ee2b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports